export default "__VITE_ASSET__BB6BuolD__"